<script>
    import BaseListener from "@/assets/plugins/mps-common/event/base-listener";
    import {ON_SYSTEM_PERMISSION_RECEIVED} from "@/framework/listeners/listeners";

    /**
     * 시스템 권한이 생성되었습니다.
     */
    export default {
        extends: BaseListener,
        name: "OnSystemPermissionReceivedListener",
        created() {
            this.registerListener(ON_SYSTEM_PERMISSION_RECEIVED, this.onSystemPermissionReceived);
        },
        beforeDestroy() {
            this.unregisterListener(ON_SYSTEM_PERMISSION_RECEIVED, this.onSystemPermissionReceived);
        }
    }
</script>
